$(".group").colorbox({
    rel:'group',
    maxHeight: '100%',
    maxWidth: '100%'
});